import React from "react"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"

import Button from "@atoms/Button/Button"
import Image from "@atoms/Image/Image"

import styles from "./HeroHighlight.module.scss"

const HeroHighlight = ({
  title,
  lead,
  links,
  headingSize,
  image,
  dominantColorEnabled,
}) => {
  const Heading = headingSize

  const linksFormatted = links
    ?.map((cta, index) => {
      const { link } = cta || {}
      return link ? (
        <Button
          key={index}
          href={link.url}
          internalLink={link.target !== "_blank"}
          linkTarget={link.target}
          variant="negative"
          anchorLink={link.url && link.url[0] === "#"}
        >
          {link.title}
        </Button>
      ) : null
    })
    .filter(Boolean)

  return (
    <>
      <section
        className={`${styles.hero} section-break-out section-break-out-no-margins-mobile large-area-element`}
      >
        {image && (
          <div className={styles.image}>
            <Image
              image={image}
              fill={true}
              dominantColorEnabled={dominantColorEnabled}
              blurred={240}
              widths={[480, 720, 1080, 1440, 1600]}
            />
          </div>
        )}

        <div className={`${styles.container} container`}>
          <div className="make-full-width-on-mobile-with-paddings">
            <Row>
              <Col lg={{ span: 12, offset: 0 }}>
                <div className={styles.content}>
                  <div className={styles.heading}>
                    <Heading>{title}</Heading>
                  </div>
                  {lead && <p className={styles.lead}>{lead}</p>}

                  {linksFormatted && linksFormatted.length > 0 && (
                    <div className={styles.cta}>{linksFormatted}</div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </section>
    </>
  )
}

HeroHighlight.defaultProps = {
  dominantColorEnabled: false,
  headingSize: "h2",
}

export default HeroHighlight
